import React from "react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";

const CreatePasswordPage = () => {
  return (
    <>
      <div className="flex flex-col h-screen w-full items-center">
        <img src={logo} alt="logo" className="w-[50%] logo" />
        <div className="flex flex-col w-[50%] signup mt-16">
          <div className="text-[20px] text-[#2F80ED] mb-2">
            Create New Password
          </div>
          <div className="text-[14px] mb-2">
            As per the instructions reset your password.
          </div>
          <div className="text-[14px] text-[#828282]">New Password</div>
          <input
            type="password"
            placeholder="*********************"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-1"
          />
          <div className="text-[14px] text-[#828282]">Re-type Password</div>
          <input
            type="password"
            placeholder="*********************"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-2"
          />

          <button className="border-none bg-[#2F80ED] py-[10px] text-white rounded-lg">
            <Link to="/subscriptions"> Login</Link>
          </button>
        </div>
      </div>
    </>
  );
};

export default CreatePasswordPage;
